exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".supported-cards{text-align:center;color:tomato}.ccicons{margin-top:10px}.ccicon-supported{height:38px;width:60px;margin-right:10px}", ""]);

// exports
